import CityPage from "@/components/feature/CityPage";

const data = {
  cityName: "Willmar",
  stateName: "Minnesota",
  stateAbbr: "MN",
  stateRoute: "/states/minnesota",
  heroImageQuery:
    "Aerial view of Willmar Minnesota west central lake city, historic downtown with charming brick buildings along Litchfield Avenue, beautiful green lakes including Foot Lake and Diamond Lake visible, Ridgewater College campus with modern buildings, surrounding agricultural landscape with golden fields and farmsteads, Minnesota prairie transitioning to lake country, residential neighborhoods with mature trees, summer day with blue sky and fluffy clouds, professional aerial photography, no readable signs or text",
  heroImageSeq: "willmar-mn-hero-2026",
  heroDescription:
    "Family trip to Mexico with your extended family in four weeks and your passport expired? European agricultural exchange with six weeks to spare? Canadian fishing trip with your Somali neighbors with three weeks notice? We help Willmar residents — from the diverse Latino and Somali communities to Ridgewater College students and west central Minnesota farm families — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other resellers. As fast as 24 hours. A+ BBB rated.",
  geoPosition: "45.1223; -95.0487",
  geoPlacename: "Willmar, Minnesota",
  geoRegion: "US-MN",
  canonicalUrl: "https://fastpassportcenter.com/willmar/",
  localAreaTitle: "Serving Willmar & West Central Minnesota",
  localAreaText: [
    "Willmar, Minnesota is the county seat of Kandiyohi County and the largest city in west central Minnesota. Located at the intersection of U.S. Highway 12 and State Highway 71, Willmar serves as the commercial, medical, and educational hub for a vast agricultural region. The city is surrounded by Minnesota's prairie lake country, with over 300 lakes in Kandiyohi County alone.",
    "Willmar has become one of Minnesota's most diverse communities, with significant Latino and Somali populations. The city has a large immigrant community, with many families having settled here to work in agriculture, food processing, and healthcare. Jennie-O Turkey Store, one of the nation's largest turkey processors, is a major employer. The agricultural economy creates a unique blend of Midwestern farm culture and international diversity.",
    "Ridgewater College, part of the Minnesota State system, provides higher education and technical training with connections to regional industries. The college serves students from across west central Minnesota and maintains partnerships with businesses and organizations. The Willmar Municipal Airport supports regional aviation and business travel.",
    "The city's location along the Glacial Ridge Trail and the Prairie Woods Environmental Learning Center provides outdoor recreation opportunities. Green Lake, Foot Lake, and Diamond Lake offer fishing, boating, and swimming. The agricultural landscape surrounding Willmar creates a distinctive rural-urban blend, with farm communities, lake cottages, and small towns dotting the countryside.",
  ],
  nearbyCities: [
    { name: "Willmar", zips: "56201" },
    { name: "Spicer", zips: "56288" },
    { name: "New London", zips: "56273" },
    { name: "Kandiyohi", zips: "56251" },
    { name: "Atwater", zips: "56209" },
    { name: "Litchfield", zips: "55355" },
  ],
  benefits: [
    {
      icon: "ri-computer-line",
      title: "Start 100% Online",
      desc: "No office visit required. Complete your order from your Willmar home or farm in minutes.",
    },
    {
      icon: "ri-truck-line",
      title: "Ship Your Documents",
      desc: "Overnight shipping from any UPS or FedEx location in the Willmar area.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Expert Document Review",
      desc: "Every application reviewed before submission to catch errors that cause delays.",
    },
    {
      icon: "ri-calendar-check-line",
      title: "Reserved Agency Access",
      desc: "Reserved submission slots at the regional passport agency — no public appointment needed.",
    },
  ],
  serviceAreaTitle: "Willmar & West Central Minnesota",
  serviceAreaDescription: "Serving Kandiyohi County and west central Minnesota communities with overnight courier",
  faqs: [
    {
      q: "How fast can I get a passport in Willmar, MN?",
      a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility. Standard government processing through a Willmar area post office can take 2–6 months — not suitable for upcoming trips.",
    },
    {
      q: "Can Willmar's diverse community get passports for family trips abroad?",
      a: "Absolutely. We regularly process expedited renewals and new applications for Willmar's diverse Latino and Somali communities planning family visits to Mexico, Somalia, and beyond. We understand the cultural importance of these family trips.",
    },
    {
      q: "Do I need to visit an office to use Fast Passport Center from Willmar?",
      a: "No — most Willmar travelers start online and ship their documents via overnight courier. There is no local Fast Passport Center office in Willmar. You can ship from FedEx or UPS locations nearby.",
    },
    {
      q: "My family is planning a trip to Mexico. How early should we start passport renewals?",
      a: "We recommend starting at least 8 weeks before departure for standard expedited processing. If you are within 3 weeks of departure, you likely need our faster 2–9 business day option. Many Willmar families plan extended visits to Mexico.",
    },
    {
      q: "What if I need a passport for a last-minute agricultural conference?",
      a: "Agricultural conferences often have short notice. We can process your passport as fast as 24 hours with proof of travel. Our emergency service is designed for exactly these situations.",
    },
    {
      q: "Are there passport acceptance facilities near Willmar?",
      a: "The Willmar Post Office, Spicer Post Office, and Litchfield Post Office all accept passport applications. We can guide you to the best option based on your schedule and situation.",
    },
  ],
  testimonials: [
    {
      name: "The Garcia Family",
      location: "Willmar, MN",
      rating: 5,
      text: "We planned a family trip to Mexico to visit our grandparents for the first time in three years. Three of our children's passports were expired. Fast Passport Center processed all four passports in seven business days. The team was incredibly kind and professional. We had an unforgettable reunion with our family.",
      service: "Family Renewal",
    },
    {
      name: "The Ibrahim Family",
      location: "Willmar, MN",
      rating: 5,
      text: "We needed passports for a family visit to Somalia. We had four weeks. Fast Passport Center processed all five family passports in six business days. The checklist was very clear and the service was excellent. We were able to visit our extended family and attend a wedding. Cannot thank them enough.",
      service: "Family Renewal",
    },
    {
      name: "Tom H.",
      location: "Willmar, MN",
      rating: 5,
      text: "I had a last-minute agricultural conference in Brazil with two weeks notice. My passport was expired. Fast Passport Center processed my renewal in four business days. I made the conference and learned about new farming techniques that I've already implemented on our farm. Excellent service.",
      service: "Business Renewal",
    },
  ],
  nearbyLinks: [
    { name: "St. Cloud", href: "/cities/st-cloud" },
    { name: "Mankato", href: "/cities/mankato" },
    { name: "Minneapolis", href: "/cities/minneapolis" },
    { name: "St. Paul", href: "/cities/st-paul" },
    { name: "Moorhead", href: "/cities/moorhead" },
    { name: "Fargo", href: "/cities/fargo" },
  ],
  introTitle: "Emergency & Expedited Passport Services in Willmar",
  introDescription: "Fast passport processing for Willmar and west central Minnesota travelers.",
  localResourcesIntro:
    "Getting your passport ready involves more than just the application. Here are local Willmar and west central Minnesota resources to help you gather everything you need before your next international trip.",
  acceptanceFacilities: [
    {
      name: "Willmar Post Office",
      address: "1301 1st St S, Willmar, MN 56201",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      phone: "(320) 235-6110",
      notes: "Primary passport acceptance facility for Willmar and Kandiyohi County residents. Appointment required. Call ahead for photo availability.",
    },
    {
      name: "Spicer Post Office",
      address: "150 Main Ave E, Spicer, MN 56288",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(320) 796-6401",
      notes: "Kandiyohi County. Full passport services. Convenient for north Willmar residents.",
    },
    {
      name: "Litchfield Post Office",
      address: "120 N Marshall Ave, Litchfield, MN 55355",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(320) 693-8241",
      notes: "Meeker County. Full passport services. Convenient for east Willmar residents.",
    },
  ],
  photoLocations: [
    { name: "Walgreens — Willmar", address: "Willmar commercial area", hours: "Call for hours" },
    { name: "CVS Pharmacy — Willmar", address: "Willmar commercial area", hours: "Daily 7 AM – 10 PM" },
    { name: "Walmart — Willmar", address: "Willmar commercial area", hours: "Call for hours" },
    { name: "The UPS Store — Willmar", address: "Willmar commercial area", hours: "Call for hours" },
  ],
  dmvLocations: [
    {
      name: "Kandiyohi County DVS Office",
      address: "Willmar, MN area",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Kandiyohi County Driver and Vehicle Services. Driver licenses, REAL ID, and passport-related ID verification.",
      featured: true,
    },
    {
      name: "Litchfield DVS Office",
      address: "Litchfield, MN area",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Meeker County DVS. Full driver and vehicle services.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "ILL",
      name: "Willmar Municipal Airport",
      distance: "About 3 miles from Willmar — 8 minutes by car",
      address: "Willmar, MN 56201",
      note: "Municipal airport for Willmar. General aviation and private flights. No commercial international service.",
      flightUrl: "https://www.willmarmn.gov/airport",
      flightLabel: "Willmar Municipal Airport",
      featured: true,
    },
    {
      code: "MSP",
      name: "Minneapolis-Saint Paul International Airport",
      distance: "About 100 miles from Willmar — 1.5 hours by car",
      address: "4300 Glumack Drive, St. Paul, MN 55111",
      note: "Major international airport for Willmar residents. Full international flight service. Access via Highway 12 and I-494.",
      flightUrl: "https://www.mspairport.com/",
      flightLabel: "MSP Airport Website",
      featured: false,
    },
    {
      code: "STC",
      name: "St. Cloud Regional Airport",
      distance: "About 60 miles from Willmar — 1 hour by car",
      address: "1550 45th Ave SE, St. Cloud, MN 56304",
      note: "Regional airport for Willmar residents. Direct flights to Chicago and Phoenix. International connections.",
      flightUrl: "https://www.stcloudairport.com/",
      flightLabel: "St. Cloud Regional Airport",
      featured: false,
    },
  ],
  travelCards: [
    {
      title: "Latino Family & Mexico Heritage Travel",
      subtitle: "Willmar's Latino community with family ties to Mexico and Central America",
      content:
        "Willmar has a significant Latino community, with many families maintaining close ties to Mexico and Central America. Extended family visits, religious celebrations, and cultural events create ongoing international travel needs. These trips are often planned around family events with specific timing.",
      tip: "Family trips to Mexico are often planned around holidays and summer. Start passport renewals early to avoid last-minute stress.",
      icon: "ri-flag-line",
    },
    {
      title: "Somali Family & East African Travel",
      subtitle: "Willmar's Somali community with family ties to Somalia and East Africa",
      content:
        "Willmar's Somali community maintains strong cultural and familial connections to East Africa. Family visits, religious pilgrimages, and cultural events create ongoing international travel needs. These trips are often planned around significant family events.",
      tip: "Family trips to East Africa are often planned months ahead. Start passport renewals early to avoid last-minute issues.",
      icon: "ri-heart-line",
    },
    {
      title: "Agricultural & Business Conference Travel",
      subtitle: "Willmar farm families and ag professionals with international trade and conference needs",
      content:
        "Willmar is at the heart of Minnesota's agricultural region. Farm families, agricultural professionals, and food industry workers frequently travel for international conferences, trade shows, and agricultural exchanges. The region's turkey processing and crop production industries create international business connections.",
      tip: "Conference invitations often come with short notice. Maintain passport validity if you are in agriculture or food processing.",
      icon: "ri-briefcase-line",
    },
    {
      title: "Study Abroad & Academic Travel",
      subtitle: "Ridgewater College students with international programs and exchanges",
      content:
        "Ridgewater College provides technical education and connects students with broader Minnesota State international programs. Students often discover passport issues during pre-departure orientation. Academic travel creates predictable passport needs.",
      tip: "Study abroad deadlines are non-negotiable. Start your passport renewal the moment you are accepted into a program.",
      icon: "ri-book-open-line",
    },
  ],
  destinations: [
    {
      name: "Mexico",
      context: "Family visits and heritage travel for Willmar's Latino community",
      urgency: "Family trips are often planned around holidays with specific dates",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Somalia",
      context: "Family visits and cultural travel for Willmar's Somali community",
      urgency: "Family trips are often planned around significant events",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Brazil",
      context: "Agricultural conferences and trade travel for farm professionals",
      urgency: "Conference invitations often arrive with short notice",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Kenya",
      context: "East African family visits and cultural travel for the diverse community",
      urgency: "Family trips are often planned around specific cultural events",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Canada",
      context: "Fishing trips and agricultural exchanges for west central Minnesota families",
      urgency: "Canadian fishing trips are often planned with short notice",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Germany",
      context: "European agricultural exchanges and heritage travel for farm families",
      urgency: "European exchanges are often planned 6+ months ahead",
      icon: "ri-map-pin-2-line",
    },
  ],
  stats: [
    { stat: "45%", label: "of Willmar expedited requests are family heritage trips to Mexico and East Africa" },
    { stat: "4–6 Weeks", label: "most common advance notice when families plan international heritage visits" },
    { stat: "Jun–Aug", label: "peak travel season for summer family visits and agricultural conferences" },
    { stat: "5–7 Days", label: "typical expedited processing time for Willmar clients choosing our recommended option" },
  ],
};

export default function WillmarMNPage() {
  return <CityPage data={data} />;
}